import { useEffect } from 'react';
import FocusTrap from 'focus-trap-react';

export function Modal({ children, onClose, className = 'max-w-lg' }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-0 sm:p-4 sm:pt-10" onClick={onClose}>
      <FocusTrap focusTrapOptions={{ allowOutsideClick: true }}>
        <div className={`w-full min-h-full sm:min-h-0 ${className} rounded-none sm:rounded-lg bg-white shadow-xl`} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
          {children}
        </div>
      </FocusTrap>
    </div>
  );
}
